import { createBrowserHistory } from 'history'
import { trackPageView } from '../components/google-analytics'

export const history = createBrowserHistory()

history.listen(() => {
  trackPageView()
})
